var chunkToChildrenMap = {
	"678": [
		4258
	],
	"1273": [
		4258
	],
	"9263": [
		4258
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));